import type { Image as ImageType } from 'mdast'
import * as React from 'react'

import { Image } from '../../image/Image'

type MarkdownImageProps = {
  node: ImageType
  className?: string
}

export const MarkdownImage = ({ node, className }: MarkdownImageProps) => (
  <Image src={node.url} alt={node.alt ?? undefined} className={className} />
)
